const mapping = new Map([
  ['01', { ap: 'Ala.', postal: 'AL', slug: '2020-alabama-election-live-results' }],
  ['02', { ap: 'Alaska', postal: 'AK', slug: '2020-alaska-election-live-results' }],
  ['04', { ap: 'Ariz.', postal: 'AZ', slug: '2020-arizona-election-live-results' }],
  ['05', { ap: 'Ark.', postal: 'AR', slug: '2020-arkansas-election-live-results' }],
  ['06', { ap: 'Calif.', postal: 'CA', slug: '2020-california-election-live-results' }],
  ['08', { ap: 'Colo.', postal: 'CO', slug: '2020-colorado-election-live-results' }],
  ['09', { ap: 'Conn.', postal: 'CT', slug: '2020-connecticut-election-live-results' }],
  ['10', { ap: 'Del.', postal: 'DE', slug: '2020-delaware-election-live-results' }],
  ['11', { ap: 'D.C.', postal: 'DC', slug: '2020-district-of-columbia-election-live-results' }],
  ['12', { ap: 'Fla.', postal: 'FL', slug: '2020-florida-election-live-results' }],
  ['13', { ap: 'Ga.', postal: 'GA', slug: '2020-georgia-election-live-results' }],
  ['13S', { ap: 'Ga.', postal: 'GA', slug: '2020-georgia-election-live-results' }],
  ['15', { ap: 'Hawaii', postal: 'HI', slug: '2020-hawaii-election-live-results' }],
  ['16', { ap: 'Idaho', postal: 'ID', slug: '2020-idaho-election-live-results' }],
  ['17', { ap: 'Ill.', postal: 'IL', slug: '2020-illinois-election-live-results' }],
  ['18', { ap: 'Ind.', postal: 'IN', slug: '2020-indiana-election-live-results' }],
  ['19', { ap: 'Iowa', postal: 'IA', slug: '2020-iowa-election-live-results' }],
  ['20', { ap: 'Kan.', postal: 'KS', slug: '2020-kansas-election-live-results' }],
  ['21', { ap: 'Ky.', postal: 'KY', slug: '2020-kentucky-election-live-results' }],
  ['22', { ap: 'La.', postal: 'LA', slug: '2020-louisiana-election-live-results' }],
  ['23', { ap: 'Maine', postal: 'ME', slug: '2020-maine-election-live-results' }],
  ['24', { ap: 'Md.', postal: 'MD', slug: '2020-maryland-election-live-results' }],
  ['25', { ap: 'Mass.', postal: 'MA', slug: '2020-massachusetts-election-live-results' }],
  ['26', { ap: 'Mich.', postal: 'MI', slug: '2020-michigan-election-live-results' }],
  ['27', { ap: 'Minn.', postal: 'MN', slug: '2020-minnesota-election-live-results' }],
  ['28', { ap: 'Miss.', postal: 'MS', slug: '2020-mississippi-election-live-results' }],
  ['29', { ap: 'Mo.', postal: 'MO', slug: '2020-missouri-election-live-results' }],
  ['30', { ap: 'Mont.', postal: 'MT', slug: '2020-montana-election-live-results' }],
  ['31', { ap: 'Neb.', postal: 'NE', slug: '2020-nebraska-election-live-results' }],
  ['32', { ap: 'Nev.', postal: 'NV', slug: '2020-nevada-election-live-results' }],
  ['33', { ap: 'N.H.', postal: 'NH', slug: '2020-new-hampshire-election-live-results' }],
  ['34', { ap: 'N.J.', postal: 'NJ', slug: '2020-new-jersey-election-live-results' }],
  ['35', { ap: 'N.M.', postal: 'NM', slug: '2020-new-mexico-election-live-results' }],
  ['36', { ap: 'N.Y.', postal: 'NY', slug: '2020-new-york-election-live-results' }],
  ['37', { ap: 'N.C.', postal: 'NC', slug: '2020-north-carolina-election-live-results' }],
  ['38', { ap: 'N.D.', postal: 'ND', slug: '2020-north-dakota-election-live-results' }],
  ['39', { ap: 'Ohio', postal: 'OH', slug: '2020-ohio-election-live-results' }],
  ['40', { ap: 'Okla.', postal: 'OK', slug: '2020-oklahoma-election-live-results' }],
  ['41', { ap: 'Ore.', postal: 'OR', slug: '2020-oregon-election-live-results' }],
  ['42', { ap: 'Pa.', postal: 'PA', slug: '2020-pennsylvania-election-live-results' }],
  ['44', { ap: 'R.I.', postal: 'RI', slug: '2020-rhode-island-election-live-results' }],
  ['45', { ap: 'S.C.', postal: 'SC', slug: '2020-south-carolina-election-live-results' }],
  ['46', { ap: 'S.D.', postal: 'SD', slug: '2020-south-dakota-election-live-results' }],
  ['47', { ap: 'Tenn.', postal: 'TN' , slug: '2020-tennessee-election-live-results'}],
  ['48', { ap: 'Texas', postal: 'TX', slug: '2020-texas-election-live-results' }],
  ['49', { ap: 'Utah', postal: 'UT', slug: '2020-utah-election-live-results' }],
  ['50', { ap: 'Vt.', postal: 'VT', slug: '2020-vermont-election-live-results' }],
  ['51', { ap: 'Va.', postal: 'VA', slug: '2020-virginia-election-live-results' }],
  ['53', { ap: 'Wash.', postal: 'WA', slug: '2020-washington-election-live-results' }],
  ['54', { ap: 'W.Va.', postal: 'WV', slug: '2020-west-virginia-election-live-results' }],
  ['55', { ap: 'Wis.', postal: 'WI', slug: '2020-wisconsin-election-live-results' }],
  ['56', { ap: 'Wyo.', postal: 'WY', slug: '2020-wyoming-election-live-results' }],
]);

export default mapping;
